import { Button, Group, Indicator, Text, Burger } from "@mantine/core";
import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetUserNotificationsCountDocument,
  UserType,
} from "/@/generated/graphql";
import { api } from "/@/services/api/api";
import { useAuthContext } from "/@/shared/contexts/AuthContext";
import { useQuery } from "@apollo/client";
import { IconBell } from "@tabler/icons-react";

import { isUserStaff } from "@jasper/shared";
import { LAYOUT_APP_BAR_HEIGHT, LayoutAppBarProps } from ".";

export const LayoutAppBarV1: FC<LayoutAppBarProps> = ({
  navbarOpened,
  toggleNavbar,
}) => {
  const { logIn, logOut, user } = useAuthContext();
  const navigate = useNavigate();

  const { data: getUserNotificationsCount } = useQuery(
    GetUserNotificationsCountDocument,
    {
      fetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    const checkIfLoggedIn = async () => {
      const user = await api.get("/users/me");
      return user;
    };
    checkIfLoggedIn()
      .then(res => {
        logIn(res.data);
      })
      .catch(() => {
        logOut();
      });
  }, []);

  return (
    <Group
      p="sm"
      gap={0}
      wrap="nowrap"
      justify="end"
      align="center"
      h={LAYOUT_APP_BAR_HEIGHT}
      style={{
        backgroundColor: "white",
        flexShrink: 0,
        borderBottom: "1px solid var(--mantine-color-ink-0)",
      }}
    >
      <Burger
        opened={navbarOpened}
        onClick={toggleNavbar}
        hiddenFrom="xs"
        size="sm"
        mr="auto"
        aria-label="Ouvrir le menu"
      />
      <Indicator
        color="red"
        disabled={
          !getUserNotificationsCount?.getUserNotificationsCount ||
          getUserNotificationsCount?.getUserNotificationsCount < 1
        }
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        mr="md"
        onClick={() => navigate("/notifications")}
      >
        <IconBell strokeWidth="1.25" />
      </Indicator>
      <Text size="md" style={{ fontWeight: "600" }}>
        {user?.type === UserType.Dentist && !user?.managedUserGroup
          ? "Dr."
          : ""}{" "}
        {user?.firstName} {user?.lastName}
      </Text>
      {(isUserStaff(user) ||
        import.meta.env.MODE !== "production" ||
        user?.allowPhysicalPrint) && (
        <Button
          color="green"
          onClick={() => navigate("/create-order-form")}
          ml={20}
          data-testid="new-order-button"
        >
          Nouvelle commande
        </Button>
      )}
    </Group>
  );
};
